import { useState, useEffect, useRef, useCallback } from "react";
import "./ProductsPage.css";
// import ProductSlider from "../pages/ProductSlider";
import {
  FiArrowLeft,
  FiArrowRight,
  FiSend,
  FiTrendingUp,
  FiDollarSign,
  FiClock,
  FiShield,
  FiFeather,
  FiAnchor,
  FiHexagon,
  FiTool,
  FiZap,
  FiUmbrella,
  FiVolumeX,
} from "react-icons/fi";
import {
  MdOutlineClose,
  MdOutlineBuild,
  MdOutlinePrecisionManufacturing,
} from "react-icons/md";
import {
  BsLightningCharge,
  BsDroplet,
  BsSoundwave,
  BiGear,
  BiCog,
  BsGear,
  BsGearWide,
  BsGearWideConnected,
  BsBrush,
} from "react-icons/bs";
import {
  GiHeavyTimer,
  GiGears,
  GiGearStickPattern,
  GiMechanicalArm,
} from "react-icons/gi";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

// Helper function to add trademark symbol to Arklon
const addTrademarkToArklon = (text) => {
  // Replace Arklon with Arklon® (case sensitive)
  return text.replace(/Arklon/g, 'Arklon®');
};

const advantages = [
  "Maintenance Free",
  "Inherently Stable",
  "Excellent Wear Resistance",
  "Good Dimensional Stability",
  "VeryGood Toughness & Resilience",
  "Self-Lubrication",
  "Noiseless & Smooth Operations",
  "Low Co-efficient of Friction",
];

const comparisonPoints = [
  {
    title: "Higher Tensile Strength & Resilience",
    description:
      "Arklon® Spools have higher tensile strength and better resilience than other spools, preventing breakage during impact and disc locking.",
  },
  {
    title: "Integrated Air Vent Design",
    description:
      "Special vents are provided in Arklon® Spools to release trapped air packets formed during lap winding.",
  },
  {
    title: "Dynamic weight balancing",
    description:
      "High precision jigs are used for balancing, improving spool stability and increasing operational life.",
  },
  {
    title: "High Molecular Weight",
    description:
      "Arklon® has high molecular weight, making the spools inherently stable",
  },
  {
    title: "Other features",
    description:
      "Other features like good toughness, self lubrication and wear resistance enable Arklon® spool to give two to three times more life than hylam or other fiber spools",
  }
];

const properties = [
  { name: "Melting Temperature", value: "215°C" },
  { name: "Material Density", value: "1.14 g/cm³" },
  { name: "Tensile Strength at Yield", value: "750 kg/cm²" },
  { name: "Hardness (Rockwell 23°C)", value: "R112" },
  { name: "Durometer (23°C)", value: "D80 - D85" },
  { name: "Flexural Strength", value: "1350 kg/cm²" },
  { name: "Notched Impact Strength", value: "2.9 Ft-Lb/in" },
  { name: "Elongation at Yield", value: "9% - 12%" },
  { name: "E-Modulus", value: "24000 kg/cm²" },
  { name: "Water Absorption (20°C)", value: "3.2% Max" },
];

const specs = [
  {
    machine: "Rieter E-32",
    name: "UNILAP",
    size: "200 mm OD × 180 mm ID × 301 L",
  },
  {
    machine: "Rieter E-36",
    name: "OMEGA LAP",
    size: "200 mm OD × 180 mm ID × 301 L",
  },
  {
    machine: "LMW LK 69 S",
    name: "LH-20",
    size: "200 mm OD × 180.2 mm ID × 300.2 L (170 mm Bore)",
  },
  {
    machine: "LMW LK64",
    name: "LH-15",
    size: "200 mm OD × 180.20 mm ID × 300.2 L (170 mm Bore)",
  },
  {
    machine: "LMW LK54",
    name: "LH-10",
    size: "200 mm OD × 180.2 mm ID × 300.2 L (178 mm Bore)",
  },
  {
    machine: "MARZOLI RD 260",
    name: "VOUK",
    size: "190 mm OD × 170 mm ID × 302 L",
  },
  {
    machine: "MARZOLI SR80",
    name: "MARZOLI",
    size: "190 mm OD × 165 mm ID × 300.2 L",
  },
  {
    machine: "MARZOLI LW/CM7",
    name: "UNILAP",
    size: "200 mm OD × 180 mm ID × 300 L",
  },
  {
    machine: "MARZOLI SR 34",
    name: "SLIVERLAP",
    size: "125 mm OD × 105 mm ID × 305 L",
  },
  {
    machine: "HARA CHERRY HL-00",
    name: "RL",
    size: "180 mm OD × 156 mm ID × 300.2 L",
  },
  {
    machine: "HARA CHERRY SL-35A",
    name: "SL",
    size: "180 mm OD × 156 mm ID × 233 L",
  },
  {
    machine: "Trutzschler T-10 lap spool",
    name: "Trutzschler",
    size: "200 mm OD × 180 mm ID × 301 L",
  },
];

// ─── ICON COMPONENTS USING REACT ICONS ──────────────────────────────────────────
const IconArrowLeft = () => <FiArrowLeft size={20} />;
const IconArrowRight = () => <FiArrowRight size={20} />;

// ─── SUB-COMPONENTS ───────────────────────────────────────────────────────────
function Modal({ product, onClose }) {
  const [activeImg, setActiveImg] = useState(0);
  const [activeTab, setActiveTab] = useState("highlights");
  const overlayRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  return (
    <div
      className="editorial-modal-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
    >
      <div className="editorial-modal">
        <button
          className="editorial-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          <MdOutlineClose size={20} />
        </button>

        <div className="editorial-modal__layout">
          <div className="editorial-modal__left">
            <div className="editorial-modal__img-wrap">
              <img
                src={product.images[activeImg]}
                alt={addTrademarkToArklon(product.title)}
                className="editorial-modal__img"
              />
              <span className="editorial-modal__cat-badge">
                {product.category}
              </span>
            </div>
            <div className="editorial-modal__thumbs">
              {product.images.map((img, i) => (
                <button
                  key={i}
                  className={`editorial-modal__thumb${i === activeImg ? " editorial-modal__thumb--on" : ""}`}
                  onClick={() => setActiveImg(i)}
                >
                  <img src={img} alt="" />
                </button>
              ))}
            </div>
          </div>

          <div className="editorial-modal__right">
            <span
              className="editorial-modal__meta-tag"
              style={{ color: product.tagColor }}
            >
              {product.tag}
            </span>
            <h2 className="editorial-modal__title">{addTrademarkToArklon(product.title)}</h2>
            <p className="editorial-modal__summary">{product.summary}</p>

            <div className="editorial-modal__stats">
              {product.stats.map((s, i) => {
                const StatIcon = s.icon;
                return (
                  <div key={i} className="editorial-modal__stat-node">
                    {StatIcon && (
                      <StatIcon
                        size={28}
                        className="editorial-modal__stat-icon"
                      />
                    )}
                    <span className="editorial-modal__stat-val">{s.value}</span>
                    <span className="editorial-modal__stat-lbl">{s.label}</span>
                  </div>
                );
              })}
            </div>

            <div className="editorial-modal__tabs">
              <button
                className={`editorial-modal__tab${activeTab === "highlights" ? " editorial-modal__tab--on" : ""}`}
                onClick={() => setActiveTab("highlights")}
              >
                Features
              </button>
              <button
                className={`editorial-modal__tab${activeTab === "applications" ? " editorial-modal__tab--on" : ""}`}
                onClick={() => setActiveTab("applications")}
              >
                Applications
              </button>
            </div>

            <div className="editorial-modal__tab-content">
              {activeTab === "highlights" && (
                <ul className="editorial-modal__highlights">
                  {product.highlights.map((h, i) => (
                    <li key={i} className="editorial-modal__highlight-item">
                      <span className="editorial-modal__highlight-icon">
                        {h.icon}
                      </span>
                      <div>
                        <strong className="editorial-modal__highlight-label">
                          {h.label}
                        </strong>
                        <p className="editorial-modal__highlight-desc">
                          {h.desc}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              {activeTab === "applications" && (
                <div className="editorial-modal__apps">
                  {product.applications.map((a, i) => (
                    <span key={i} className="editorial-modal__app-tag">
                      {a}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="editorial-modal__footer">
              <a
                href={`https://wa.me/919495958871?text=Hi, I'm interested in ${encodeURIComponent(addTrademarkToArklon(product.title))}.`}
                className="editorial-modal__cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FiSend size={18} />
                Request Specifications
              </a>
              <p className="editorial-modal__spec-note">
                Custom profile options built directly to technical drawings.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SlideText({ product, animKey }) {
  return (
    <div key={animKey} className="editorial-slider-text editorial-fade-in">
      <span className="editorial-slider-cat">{product.category}</span>
      <h2 className="editorial-slider-title">{addTrademarkToArklon(product.name)}</h2>
      <p className="editorial-slider-sub">{product.subtitle}</p>
      <p className="editorial-slider-desc">{product.desc}</p>

      <div className="editorial-slider-specs">
        <div className="editorial-slider-spec-item">
          <span>Dimensions (OD × ID × L)</span>
          <strong>
            {product.dimensions.od} × {product.dimensions.id} ×{" "}
            {product.dimensions.length}
          </strong>
        </div>
        <div className="editorial-slider-spec-item">
          <span>Material Base</span>
          <strong>{product.material}</strong>
        </div>
      </div>
    </div>
  );
}

function ImageGallery() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [hoveredImageId, setHoveredImageId] = useState(null);
  const [modalActiveImage, setModalActiveImage] = useState(0);

  const galleryImages = [
    {
      id: 1,
      name: "E-32 UNILAP lap spool",
      size: "200 mm OD × 180 mm ID × 301 L",
      image: "/assets/E-32 UNILAP lap spool1.jpeg",
      secondImage: "/assets/E-32 UNILAP lap spool2.jpeg"
    },
    {
      id: 2,
      name: "E-36 OMEGA lap spool",
      size: "200 mm OD × 180 mm ID × 301 L",
      image: "/assets/E-36 Omega lap spool1.jpeg",
      secondImage: "/assets/E-36 Omega lap spool2.jpeg"
    },
    {
      id: 3,
      name: "LMW LK54 LH-10 lap spool",
      size: "200 mm OD × 180.2 mm ID × 300.2 L (178 mm Bore)",
      image: "/assets/LH -10 Lap spool1.jpeg",
      secondImage: "/assets/LH -10 Lap spool2.jpeg"
    },
    {
      id: 4,
      name: "LMW LK64 LH-15 Lap spool",
      size: "200 mm OD × 180.20 mm ID × 300.2 L (170 mm Bore)",
      image: "/assets/LH-15Sspool1.png",
      secondImage: "/assets/LH-15Sspool2.png"
    },
    {
      id: 5,
      name: "LH-20 Lap spool",
      size: "200 mm OD × 180.2 mm ID × 300.2 L (170 mm Bore)",
      image: "/assets/LH-20spool1.png",
      secondImage: "/assets/LH-20spool2.png"
    },
    {
      id: 6,
      name: "MARZOLI SR80 lap spool",
      size: "190 mm OD × 165 mm ID × 300.2 L",
      image: "/assets/Marzoli sr 80 lap spool1.jpeg",
      secondImage: "/assets/Marzoli sr 80 lap spool2.jpeg"
    },
    {
      id: 7,
      name: "Marzoli UniLap Spool",
      size: "200 mm OD × 180 mm ID × 300 L",
      image: "/assets/marzoli spool1.jpeg",
      secondImage: "/assets/marzoli spool2.jpeg"
    },
    {
      id: 8,
      name: "MARZOLI RD 260 VOUK lap spools",
      size: "190 mm OD × 170 mm ID × 302 L",
      image: "/assets/Vouk Rd-3001.jpeg",
      secondImage: "/assets/Vouk Rd-3002.jpeg"
    },
    {
      id: 10,
      name: "Cherry hara",
      size: "180 mm OD × 156 mm ID × 300.2 L",
      image: "/assets/Cherry hara Sl1.jpeg",
      secondImage: "/assets/Cherry hara Sl2.jpeg"
    },
    {
      id: 11,
      name: "Trutzschler T-10 lap Spools",
      size: "200 mm OD × 180 mm ID × 301 L",
      image: "/assets/Trutzschler  T-10 lap spool1.jpeg",
      secondImage: "/assets/Trutzschler  T-10 lap spool2.jpeg"
    },
  ];

  const openFullscreen = (image, index) => {
    setSelectedImage(image);
    setModalActiveImage(0);
    setIsFullscreen(true);
    document.body.style.overflow = "hidden";
  };

  const closeFullscreen = () => {
    setIsFullscreen(false);
    setSelectedImage(null);
    setModalActiveImage(0);
    document.body.style.overflow = "";
  };

  const nextImage = () => {
    if (selectedImage && selectedImage.images) {
      setModalActiveImage((prev) => (prev + 1) % selectedImage.images.length);
    }
  };

  const prevImage = () => {
    if (selectedImage && selectedImage.images) {
      setModalActiveImage((prev) => (prev - 1 + selectedImage.images.length) % selectedImage.images.length);
    }
  };

  // Handle escape key press
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isFullscreen) {
        closeFullscreen();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isFullscreen]);

  // Prepare images with both views for modal
  const imagesWithBoth = galleryImages.map(img => ({
    ...img,
    images: [img.image, img.secondImage]
  }));

  return (
    <>
      <section className="image-gallery-section">
        <div className="image-gallery-container">
          <div className="gallery-header">
            <span className="gallery-badge">PRODUCT GALLERY</span>
            <h2 className="gallery-title">
              Our Product &nbsp;
              <span className="gradient-text">Range</span>
            </h2>
            <p className="gallery-description">
              Hover to see different angles | Click to view in fullscreen
            </p>
          </div>

          <div className="gallery-grid">
            {imagesWithBoth.map((item, idx) => (
              <div
                key={item.id}
                className="gallery-item"
                onMouseEnter={() => setHoveredImageId(item.id)}
                onMouseLeave={() => setHoveredImageId(null)}
                onClick={() => openFullscreen(item, idx)}
              >
                <div className="gallery-image-wrapper">
                  <img
                    src={hoveredImageId === item.id ? item.secondImage : item.image}
                    alt={item.name}
                    className="gallery-image"
                    loading="lazy"
                  />
                  <div className="gallery-overlay">
                    <span className="gallery-view-text">Click to enlarge</span>
                  </div>
                </div>
                <div className="gallery-info">
                  <h3 className="gallery-item-name">{item.name}</h3>
                  <p className="gallery-item-size">{item.size}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fullscreen Modal with dual images */}
      {isFullscreen && selectedImage && (
        <div className="fullscreen-modal" onClick={closeFullscreen}>
          <button className="fullscreen-close" onClick={closeFullscreen}>
            <MdOutlineClose size={30} />
          </button>

          <button className="fullscreen-nav fullscreen-nav-prev" onClick={(e) => {
            e.stopPropagation();
            prevImage();
          }}>
            <FaArrowLeft size={30} />
          </button>

          <button className="fullscreen-nav fullscreen-nav-next" onClick={(e) => {
            e.stopPropagation();
            nextImage();
          }}>
            <FaArrowRight size={30} />
          </button>

          <div
            className="fullscreen-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.images[modalActiveImage]}
              alt={selectedImage.name}
              className="fullscreen-image"
            />
            <div className="fullscreen-info">
              <h3>{selectedImage.name}</h3>
              <p className="fullscreen-size">{selectedImage.size}</p>
              <div className="fullscreen-thumbnails">
                {selectedImage.images.map((img, i) => (
                  <button
                    key={i}
                    className={`fullscreen-thumb ${modalActiveImage === i ? 'active' : ''}`}
                    onClick={() => setModalActiveImage(i)}
                  >
                    <img src={img} alt={`View ${i + 1}`} />
                  </button>
                ))}
              </div>
              <p className="fullscreen-counter">
                {modalActiveImage + 1} / {selectedImage.images.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ─── MAIN EXPORT COMPONENT ───────────────────────────────────────────────────
export default function ProductsPage() {
  const [activeProduct, setActiveProduct] = useState(null);

  // Custom hook to trigger scroll reveal animations gracefully
  function useScrollReveal() {
    const ref = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("emk-revealed");
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.15 },
      );

      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, []);

    return ref;
  }

  const visualRef = useScrollReveal();

  return (
    <div className="editorial-page">
      {activeProduct && (
        <Modal product={activeProduct} onClose={() => setActiveProduct(null)} />
      )}

      {/* Editorial Journal Header with Background Image */}
      <header className="editorial-hero">
        <div className="editorial-hero__overlay"></div>
        <div className="editorial-hero__wrapper">
          {/* <span className="editorial-hero__label">
            {addTrademarkToArklon("Arklon Laps Pool Journal")}
          </span> */}
          <h1 className="editorial-hero__title">
            {addTrademarkToArklon("Arklon")} LapSpools where
            <br />
            Tolerance meets Consistency
          </h1>
          <p className="editorial-hero__standfirst">
            Exploring the performance metrics of high-molecular polyamide
            solutions designed explicitly for high-friction industrial
            environments.
          </p>
          <div className="editorial-hero__meta">
            <span>Production Profiles</span>
            <span>Est. 1997</span>
            <span>National Scale</span>
          </div>
          <div className="editorial-scroll-notify">
            <span className="editorial-scroll-notify__text">Scroll Down</span>
            <div className="editorial-scroll-notify__mouse">
              <div className="editorial-scroll-notify__wheel"></div>
            </div>
          </div>
        </div>
      </header>

      <ImageGallery />

      <div className="gql-page">
        <div className="emk-about-container">
          {/* SECTION HEADER BLOCK */}
          <div className="emk-about-header">
            <div className="emk-meta-layer">
              <span className="emk-num-badge">MATERIAL INNOVATION</span>
            </div>
            <h2 className="emk-split-title">
              {addTrademarkToArklon("Arklon")} Polyamide <br />
              <span className="emk-gradient-text">The Engineering Core.</span>
            </h2>
            <p className="emk-lead-p">
              {addTrademarkToArklon("Arklon")} is a highly versatile, premium engineering polyamide
              manufactured using a continuous{" "}
              <strong>Monomer Centrifugal Casting Technology</strong>.
              Polymerization takes place at the molten stage, allowing the
              molecular arrays to lock seamlessly. This results in stable
              configurations engineered to last{" "}
              <strong>2 to 3 times longer</strong> than outdated Hylam or fiber
              composite industrial spools.
            </p>
          </div>

          {/* MAIN ASYMMETRIC CONTENT GRID */}
          <div className="emk-about-grid">
            {/* LEFT COLUMN: CRITICAL DATA BOARDS */}
            <div className="emk-data-panel">
              {/* TECHNICAL CARD 2: PROPERTIES SPECS */}
              <div className="emk-bento-card material-properties">
                <h3>Structural Properties Matrix</h3>
                <div className="emk-properties-table">
                  {properties.map((prop, i) => (
                    <div key={i} className="emk-table-row">
                      <span className="prop-name">{prop.name}</span>
                      <span className="prop-value">{prop.value}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* TECHNICAL CARD 3: ADVANTAGES ARRAY */}
              <div className="emk-bento-card operational-advantages">
                <h3>Engineering Advantages</h3>
                <div className="emk-advantages-matrix">
                  {advantages.map((adv, i) => (
                    <div key={i} className="emk-adv-tag">
                      <span className="adv-indicator">■</span> {adv}
                    </div>
                  ))}
                </div>
              </div>

              {/* TECHNICAL CARD 4: COMPARISON ADVANTAGES */}
              <div className="emk-bento-card comparison-card">
                <h3>Comparison of High Impact Grade {addTrademarkToArklon("Arklon")} Spools with other spools</h3>

                <div className="comparison-points">
                  {comparisonPoints.map((item, i) => (
                    <div key={i} className="comparison-point">
                      <div className="comparison-dot"></div>

                      <div className="comparison-content">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN: INDUSTRIAL VIEWPORT & SPECIFICATIONS SHEET */}
            <div className="emk-visual-panel">
              {/* COMPONENT REVEAL INTERACTIVE BLOCK */}
              <div ref={visualRef} className="emk-reveal-trigger">
                <div className="emk-shroud-cover" />

                <div className="emk-bento-hero-card">
                  <div className="emk-blueprint-grid" />
                  <div className="emk-corner-ticks tl" />
                  <div className="emk-corner-ticks tr" />
                  <div className="emk-corner-ticks bl" />
                  <div className="emk-corner-ticks br" />

                  <img
                    src="/assets/one.png"
                    alt={`${addTrademarkToArklon("Arklon")} High Impact Lap Spool Core`}
                    className="emk-tech-img"
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/400x300?text=Arklon+Spool";
                    }}
                  />

                  <div className="emk-badge-glass">
                    <div className="emk-badge-huge">3x</div>
                    <div className="emk-badge-lbl">
                      EXTENDED LIFECYCLE OVER HYLAM FIBER
                    </div>
                  </div>
                </div>
              </div>

              {/* MACHINE COMPATIBILITY ENGINE SPECIFICATIONS */}
              <div className="emk-bento-card machine-specifications">
                <h3>Compatibility &amp; Dimension Array</h3>
                <div className="emk-spec-scroll-area">
                  <table className="emk-spec-table">
                    <thead>
                      <tr>
                        <th>Machine OEM</th>
                        <th>Spool Configuration</th>
                        <th>Dimensional Metrics</th>
                      </tr>
                    </thead>
                    <tbody>
                      {specs.map((spec, i) => (
                        <tr key={i}>
                          <td className="spec-oem">{spec.machine}</td>
                          <td className="spec-name">{spec.name}</td>
                          <td className="spec-size">
                            <code>{spec.size}</code>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── FULL-WIDTH SPEC STRIP (Seamless Loop Ticker) ── */}
        <section className="gql-spec-strip">
          <div className="gql-spec-strip__label">
            Key Specifications at a glance
          </div>
          <div className="gql-spec-strip__wrapper">
            <div className="gql-spec-strip__items">
              {properties.map((p, i) => (
                <div key={`orig-${i}`} className="gql-spec-strip__item">
                  <span className="gql-spec-strip__val">{p.value}</span>
                  <span className="gql-spec-strip__key">{p.name}</span>
                </div>
              ))}
            </div>
            <div className="gql-spec-strip__items" aria-hidden="true">
              {properties.map((p, i) => (
                <div key={`dup-${i}`} className="gql-spec-strip__item">
                  <span className="gql-spec-strip__val">{p.value}</span>
                  <span className="gql-spec-strip__key">{p.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* Primary Highlight Experience Slider */}
      {/* <ProductSlider /> */}

      {/* Editorial Footer Strip */}
      <footer className="editorial-footer">
        <div className="editorial-footer__content">
          <div>
            <p className="editorial-footer__creed">
              Precision components built for extreme real-world stress metrics.
            </p>
          </div>
          <a
            href="https://wa.me/919495958871"
            className="editorial-footer__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Initiate Consultation →
          </a>
        </div>
      </footer>
    </div>
  );
}